<template>
  <div class="c-adapt">
    <div class="c-adapt__condition">
      <div class="use-condition">
        <div class="use-condition">
            <header class="use-condition__header">使用情况</header>
          <div class="use-condition__flex">
              <div class="use-condition__number">
                <div class="fz-20">智适应班级总数</div>
                <div class="fz-40">
                  <span class="mr-5">{{classNum}}</span>
                  <span style="font-size:20px ;font-weight: 400;">个</span>
                </div>
              </div>
              <div class="use-condition__number">
                <div class="fz-20">智适应老师人数</div>
                <div class="fz-40">
                  <span class="mr-5">{{teacherNum}}</span>
                  <span style="font-size:20px;font-weight: 400;">个</span>
                </div>
              </div>
              <div class="use-condition__number">
                <div class="fz-20">智适应学生人数</div>
                <div class="fz-40">
                  <span class="mr-5">{{studentNum}}</span>
                  <span style="font-size:20px;font-weight: 400;">个</span>
                </div>
              </div>
          </div>
        </div>
      </div>
      <SubjectDistribute :subjectList="mentallyList.student_num_by_subject"
      :gradeList="mentallyList.student_num_by_grade"
      :studentNum="mentallyList.date_range_student_num"
      />
    </div>
    <div class="c-adapt__study">
      <div class="study-condition">
        <div class="study-condition" v-if="mentallyList.learn_info">
            <header class="study-condition__header">学习数据</header>
          <div class="study-condition__flex">
              <div class="study-condition__number h-226">
                <div class="fz-20">测评知识点总数</div>
                <div class="fz-40 hg-30">
                  <span class="mr-5">{{mentallyList.learn_info.tag_code_num}}</span>
                  <span style="font-size:20px ;font-weight: 400;">个</span>
                </div>
                <div class="fz-16">
                  <span class="avg_circle"></span> 人均测学:<span class="avg_unit">
                    {{mentallyList.learn_info.average_tag_code_num}}个</span> </div>
              </div>
              <div class="study-condition__number h-226">
                <div class="fz-20">测出薄弱知识点数</div>
                <div class="fz-40 hg-30">
                  <span class="mr-5"> {{mentallyList.learn_info.weak_tag_code_num}}</span>
                  <span style="font-size:20px ;font-weight: 400;">个</span>
                </div>
                <div class="fz-16">
                  <span class="avg_circle"></span >人均测出:<span class="avg_unit">
                    {{mentallyList.learn_info.average_weak_tag_code_num}}个</span>
                  </div>
              </div>
              <div class="study-condition__number h-226">
                <div class="fz-20">攻克薄弱知识点数</div>
                <div class="fz-40 hg-30">
                  <span class="mr-5">{{mentallyList.learn_info.conquer_tag_code_num}}</span>
                  <span style="font-size:20px ;font-weight: 400;">个</span>
                </div>
                <div class="fz-16"><span class="avg_circle"></span>
                人均攻克: <span class="avg_unit">
                  {{mentallyList.learn_info.average_conquer_tag_code_num}}个</span></div>
              </div>
              <div class="study-condition__number">
                <div class="fz-20">累计答题数</div>
                <div class="fz-40">
                  <span class="mr-5">{{mentallyList.learn_info.total_answer_question}}</span>
                  <span style="font-size:20px ;font-weight: 400;">个</span>
                </div>
              </div>
              <div class="study-condition__number">
                <div class="fz-20">累计答题时长</div>
                <div class="fz-40">
                  <span class="mr-5">{{mentallyList.learn_info.total_learn_time}}</span>
                  <span style="font-size:20px ;font-weight: 400;">分钟</span>
                </div>
              </div>
              <div class="study-condition__number">
                <div class="fz-20">平均正答率</div>
                <div class="fz-40">
                  <span class="mr-5">
                    {{Math.floor(mentallyList.learn_info.average_correct_rate * 100)}}
                  </span>
                  <span style="font-size:20px ;font-weight: 400;">%</span>
                </div>
              </div>
          </div>
        </div>
      </div>
      <LearningEffect :masteryDegree="mentallyList.tag_code_mastery_degree"/>
    </div>
    <KnowledgeTrend
    :codeTrend="mentallyList.tag_code_trend"
    :classContrast="mentallyList.tag_code_class_contrast"/>
  </div>
</template>

<script>
import SubjectDistribute from './subject-distribute.vue';
import LearningEffect from './learning-effect.vue';
import KnowledgeTrend from './knowledge-trend.vue';

export default {
  name: 'Mentally',
  components: {
    SubjectDistribute,
    LearningEffect,
    KnowledgeTrend,
  },
  props: {
    mentallyList: {
      require: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    classNum() {
      return this.mentallyList.survey_info && this.mentallyList.survey_info.class_num;
    },
    teacherNum() {
      return this.mentallyList.survey_info && this.mentallyList.survey_info.teacher_num;
    },
    studentNum() {
      return this.mentallyList.survey_info && this.mentallyList.survey_info.student_num;
    },
  },
  watch: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.c-adapt{
  padding-top: 40px;
  &__condition{
    display: flex;
    margin-bottom:41px ;
    .use-condition{
      box-sizing: border-box;
      width: 722px;
      height: 404px;
      margin-right: 40px;
      background: url('../../images/use_condition_bg.png') no-repeat top left / 722px 404px;
      .fz-20 {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
      }
      .fz-40 {
        font-size: 40px;
        font-weight: 600;
        color: #00DEFF;
        line-height: 56px;
      }

      &__header {
        position: relative;
        font-size: 28px;
        font-weight: 500;
        top: 20px;
        text-indent: 1em;
        color: #E3E2FF;
        margin-left: 44px;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
        }
      }
      &__flex {
        display: flex;
        justify-content: space-around;
        padding: 0 22px;
      }
      &__number {
        position: relative;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: space-around;
        width: 190px;
        height: 194px;
        margin-top: 53px;
        background: url('../../images/study-data-bg.png') no-repeat top left / 100% 100%;
        &::before {
          content: '';
          position: absolute;
          width: 220px;
          height: 50px;
          bottom: -52px;
          left: -15px;
          background: url('../../images/bg-show.png') no-repeat top left / 100% 100%;
        }
      }
    }
  }
  &__study{
     display: flex;
    margin-bottom:40px ;
    .study-condition{
      box-sizing: border-box;
      width: 722px;
      height: 686px;
      margin-right: 40px;
      background: url('../../images/study_data_bg.png') no-repeat top left / 100% 100%;
      .fz-20 {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
      }
      .fz-40 {
        font-size: 40px;
        font-weight: 600;
        color: #00DEFF;
        line-height: 56px;
      }

       .hg-30{
        height: 30px;
      }
      .fz-16{
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        .avg_circle{
          display: inline-block;
          width: 8px;
          height: 8px;
          background: #00DEFF;
          border-radius:50% ;
          margin-right:3px ;
        }
        .avg_unit{
          color: #00DEFF;
          margin-left:4px ;
        }
      }
      &__header {
        position: relative;
        font-size: 28px;
        font-weight: 500;
        top: 20px;
        text-indent: 1em;
        color: #E3E2FF;
        margin-left: 44px;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
        }
      }
      &__flex {
        display: flex;
        justify-content: space-around;
        flex-wrap:wrap;
        padding: 0 22px;
      }
      &__number {
        position: relative;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: space-around;
        width: 190px;
        height: 194px;
        margin-top: 53px;
        background: url('../../images/study-data-bg.png') no-repeat top left / 100% 100%;
        &::before {
          content: '';
          position: absolute;
          width: 220px;
          height: 50px;
          bottom: -52px;
          left: -15px;
          background: url('../../images/bg-show.png') no-repeat top left / 100% 100%;
        }
      }
    }
  }
}
.h-226 {
  height: 226px !important;
}
.mr-5{
  margin-right: 5px;
}
</style>
